import { render, staticRenderFns } from "./ShareAdd.vue?vue&type=template&id=38dd6664&scoped=true&"
import script from "./ShareAdd.vue?vue&type=script&lang=js&"
export * from "./ShareAdd.vue?vue&type=script&lang=js&"
import style0 from "./ShareAdd.vue?vue&type=style&index=0&id=38dd6664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd6664",
  null
  
)

export default component.exports